import React, { useEffect, useState } from "react";

export default function Qlinn(props) {
  console.log(props);
  const [link, setLink] = useState("");
  useEffect(() => {
    setLink(`https://qlinn.rt-itservices.co.uk?order=${props.orderId}`);
  }, [props.orderId]);

  return (
    <div style={{ color: "black" }}>
      <iframe
        src={link}
        allow="clipboard-read; clipboard-write"
        height="845px"
        width="1838px"
        title="Qlinn"></iframe>
    </div>
  );
}
